export const CategoriesData = [
  {
    _id: "1",
    title: "Fantasy",
  },
  {
    _id: "2",
    title: "Horror",
  },
  {
    _id: "3",
    title: "Thriller",
  },
  {
    _id: "4",
    title: "Comedy",
  },
  {
    _id: "5",
    title: "Family",
  },
  {
    _id: "6",
    title: "Family",
  },
  {
    _id: "7",
    title: "Action",
  },
  {
    _id: "8",
    title: "Horror",
  },
  {
    _id: "9",
    title: "Western",
  },
  {
    _id: "10",
    title: "Western",
  },
  {
    _id: "11",
    title: "Western",
  },
];
